<script setup lang="ts">
import AppButton from '@/application/components/ui/AppButton.vue';
import { storeToRefs } from "pinia";
import { useUserStore } from "@/user/store/userStore";
import SvgVue from "@/application/components/SvgVue";
import { BiometryType } from "@/application/plugins/biometricAuth";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { ref, watch } from "vue";
import {
  resetSystemBarsStyle,
  setSystemBarsStyle,
  SystemBarsStyle,
} from '@/application/utils/systemBars.ts';

const { isAppLocked, biometry } = storeToRefs(useUserStore());
const buttonIcon = ref('');

watch(
  [biometry, isAppLocked],
  async ([newBiometry, appIsLocked]) => {
    if (!appIsLocked) {
      await resetSystemBarsStyle(); // dunkle Icons auf hellem App-Hintergrund
      return // early return to prevent calling unlockApp before the app is locked
    }

    await setSystemBarsStyle(SystemBarsStyle.Dark);

    switch (newBiometry?.biometryType) {
      case BiometryType.touchId:
      case BiometryType.fingerprintAuthentication:
        buttonIcon.value = 'fingerprint';
        await unlock();
        break;
      case BiometryType.faceId:
      case BiometryType.faceAuthentication:
      case BiometryType.irisAuthentication:
        buttonIcon.value = 'face-viewfinder';
        break;
      default:
        buttonIcon.value = '';
    }
  },
  { immediate: true },
);

async function unlock(): Promise<void> {
  return await useUserStore().unlockApp();
}

async function handleUnlock() {
  useUserStore().resetAppUnlockErrorCode();
  await unlock();
}
</script>

<template>
  <Transition name="fade-out">
    <div
      v-if="isAppLocked"
      class="overlay h-dvh overflow-hidden grid w-full grid-rows-3 grid-cols-1 p-10 relative items-center"
      style="background: #2360B0;"
    >
      <div />
      <div>
        <SvgVue icon="logo.svg" alt="" class="w-32 mx-auto" />
      </div>
      <div class="pointer-events-auto">
        <div class="max-w-80 mx-auto ">
          <AppButton
            native-type="submit"
            type="primary"
            text
            bg
            class="w-full"
            :handler="handleUnlock"
          >
            <FontAwesomeIcon v-if="buttonIcon" :icon="['fal', buttonIcon]" class="mr-2" size="xl" />
            Entsperren
          </AppButton>
        </div>
      </div>
    </div>
  </Transition>
</template>
